module.exports = __webpack_public_path__ + "static/media/hotdog.4765b8b4.svg";